$(window).load(function () {
  init_top_carousel();
  init_count_selector();
});

function init_top_carousel() {
  if ($('#topSlider').length > 0) {
    var carousel = $('#topSlider').owlCarousel({
      margin: 0,
      loop: true,
      nav: true,
      autoWidth: true,
      responsive: {
        0: {
          items: 1
        },
        1000: {
          items: 3
        }
      }
    });
  }
  if ($('.giftSlider').length > 0) {
    var carousel = $('.giftSlider').owlCarousel({
      loop: true,
      autoWidth: false,
      nav: true,
      items: 2,
      responsive: {
        0: {
          center: false
        },
        1000: {
          items: 4,
          autoWidth: false,
          center: false,
        }
      }
    });
  }
  if ($('#bestSellerSlider').length > 0) {
    var carousel = $('#bestSellerSlider').owlCarousel({
      loop: true,
      autoWidth: false,
      nav: true,
      items: 2,
      responsive: {
        0: {
          center: false
        },
        1000: {
          items: 4,
          autoWidth: false,
          center: false,
        }
      }
    });
  }

  if ($('#relatedSlider').length > 0) {
    var carousel = $('#relatedSlider').owlCarousel({
      loop: true,
      autoWidth: false,
      nav: true,
      items: 2,
      responsive: {
        0: {
          center: false
        },
        1000: {
          items: 4,
          autoWidth: false,
          center: false,
        }
      }
    });
  }

  if ($('#relatedSliderSpecial').length > 0) {
    if ($(window).width() < 1000) {
      $('#relatedSliderSpecial').owlCarousel({
        loop: true,
        autoWidth: false,
        nav: true,
        items: 2,
      });
    }
  }

  if ($(window).width() <= 1000 && $('.shopList').length > 0) {
    $('.shopList').owlCarousel({
      loop: true,
      autoWidth: false,
      nav: true,
      items: 1
    });
  }
}

function init_count_selector() {
  if ($('.btn_product_selector').length > 0) {
    $('.btn_product_selector .minus').click(function () {
      var count = parseInt($(this).siblings('.count').text());
      if (count !== undefined) {
        count = count > 0 ? count - 1 : 0;
        $(this).parent().find('.count').text(count);
      }
    });
    $('.btn_product_selector .plus').click(function () {
      var count = parseInt($(this).siblings('.count').text());
      if (count !== undefined) {
        count = count > 0 ? count + 1 : 0;
        $(this).parent().find('.count').text(count);
      }
    });
  }
  if ($('.btn_heart').length > 0) {
    $('.btn_heart').click(function () {
      if ($('.btn_heart').hasClass('active')) {
        $('.btn_heart').removeClass('active');
      } else {
        $('.btn_heart').addClass('active');
      }
    });
  }
  if ($('.detailPriceGallary').length > 0) {
    $('.detailPriceGallaryItems .btn').click(function () {
      if (!$(this).hasClass('active')) {
        var src = $(this).data('src');
        var parent = $(this).closest('.detailPriceGallary');
        if (parent.length > 0 && parent.find('.detailPriceGallaryImg').length > 0) {
          parent.find('.detailPriceGallaryImg img').attr('src', src);
          parent.find('.btn').removeClass('active');
          $(this).addClass('active');
        }
      }
    });
  }
}

// Increment and Decrement Value
function decrementValue(id) {
  var value = $(id).val();
  value = isNaN(value) ? 0 : value;
  if (value > 1) {
    value--;
  }
  $(id).val(value);
}

function incrementValue(id) {
  var value = $(id).val();
  value = isNaN(value) ? 0 : value;
  value++;
  $(id).val(value);
}

// Related Slider Special
$(window).resize(function () {
  if ($(window).width() < 1000) {
    if ($('#relatedSliderSpecial').length > 0) {
      $('#relatedSliderSpecial').owlCarousel({
        loop: true,
        autoWidth: false,
        nav: true,
        items: 2,
      });
    }
  } else {
    if ($('#relatedSliderSpecial').length > 0) {
      var owl = $('#relatedSliderSpecial');
      owl.trigger('destroy.owl.carousel');
    }
  }
});

// 商品ページアコーディオン
$(document).ready(function () {
  $('.accordion-header').click(function () {
    $(this).next('.accordion-body').slideToggle(200);
    $(this).find('.accordion-icon .icon-plus').toggle();
    $(this).find('.accordion-icon .icon-minus').toggle();
  });
});

// ギフトページ価格別タブ切替
$(document).ready(function() {
  $('.tab-header').click(function (){
    $('.tab-header').removeClass('active');
    $(this).addClass('active');
    var id = $(this).attr('id');
    $('.price-collection').hide();
    $('.'+id).css('display','flex')
  });
});

$(document).ready(function () {
  var adjust = -100;
  var speed = 500;

  $('#pick-up-button').on('click', function () {
    var position = $('#gift-pickup').offset().top + adjust;
    $('body,html').animate({scrollTop:position}, speed, 'swing');
  });
  $('#category-button').on('click', function () {
    var position = $('#onlineCategory').offset().top + adjust;
    $('body,html').animate({scrollTop:position}, speed, 'swing');
  });
  $('#price-button').on('click', function () {
    var position = $('#gift-price').offset().top + adjust;
    $('body,html').animate({scrollTop:position}, speed, 'swing');
  });

});
